import {PlatformRoute} from "@tracabois/template";
import {LogoutPage} from "../Logout";

export const LogoutRoutes: PlatformRoute[] = [
    {
        path: "/logout",
        components: <LogoutPage />
    },
]
